import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";

export function ClientRosterCard() {
  const [clients, setClients] = useState(null);
  const [q, setQ] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/clients").then((r) => setClients(Array.isArray(r.data) ? r.data : (r.data.clients || []))).catch((e) => toast.error(formatApiError(e)));
  }, []);

  const name = (c) => c.full_name || c.name || c.forms?.intake?.full_name || c.client_code || "Unnamed";
  const fmtDate = (iso) => {
    if (!iso) return "—";
    const d = new Date(`${String(iso).slice(0, 10)}T12:00:00`);
    return Number.isNaN(d.getTime()) ? iso : d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  };
  const active = (clients || []).filter((c) => String(c.status || "").toLowerCase() !== "inactive");
  const shown = active
    .filter((c) => {
      const haystack = `${name(c)} ${c.phone || ""} ${c.email || ""}`.toLowerCase();
      return !q.trim() || haystack.includes(q.trim().toLowerCase());
    })
    .sort((a, b) => String(a.service_start_date || "9999").localeCompare(String(b.service_start_date || "9999")) || name(a).localeCompare(name(b)));

  return (
    <div className="mb-8 rounded-xl border border-stone-200 bg-white shadow-sm" data-testid="client-roster-card">
      <div className="flex flex-wrap items-center justify-between gap-2 border-b border-stone-100 px-6 py-4">
        <div>
          <h2 className="font-heading text-2xl tracking-tight text-[#4A235A]">Client roster</h2>
          <p className="text-xs text-stone-500" data-testid="client-roster-count">{active.length} current clients · start / last service / phone / email</p>
        </div>
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Find name, phone, or email…"
          className="h-8 w-64 rounded-md border border-stone-300 bg-white px-2 text-xs" data-testid="client-roster-search" />
      </div>
      <div className="hidden grid-cols-[1.2fr_0.6fr_0.65fr_0.75fr_1fr] gap-3 border-b border-stone-100 px-6 py-2 text-[10px] font-bold uppercase tracking-wide text-stone-400 lg:grid">
        <span>Client</span><span>Start</span><span>Last service</span><span>Phone</span><span>Email</span>
      </div>
      <div className="max-h-72 divide-y divide-stone-50 overflow-y-auto px-2 py-1" data-testid="client-roster-list">
        {clients === null && <p className="px-4 py-6 text-center text-xs text-stone-400">Loading…</p>}
        {clients !== null && shown.length === 0 && <p className="px-4 py-6 text-center text-xs text-stone-400" data-testid="client-roster-empty">No clients match.</p>}
        {shown.map((c) => (
          <button key={c.id} onClick={() => navigate(`/clients/${c.id}`)}
            className="grid w-full grid-cols-1 gap-2 rounded-md px-4 py-2.5 text-left transition-colors hover:bg-primary/5 lg:grid-cols-[1.2fr_0.6fr_0.65fr_0.75fr_1fr] lg:items-center lg:gap-3"
            data-testid={`client-roster-${c.id}`}>
            <span className="min-w-0">
              <span className="block truncate text-sm font-medium text-stone-800">{name(c)}</span>
              {!c.service_start_date && <span className="text-[10px] font-semibold text-[#B7791F]">start date needs review</span>}
            </span>
            <span className="text-[11px] text-stone-600" data-testid={`client-roster-start-${c.id}`}><span className="lg:hidden font-semibold">Start · </span>{fmtDate(c.service_start_date)}</span>
            <span className="text-[11px] text-stone-600" data-testid={`client-roster-last-${c.id}`}><span className="lg:hidden font-semibold">Last service · </span>{fmtDate(c.last_service_date)}</span>
            <span className="truncate text-[11px] text-stone-600" data-testid={`client-roster-phone-${c.id}`}>{c.phone || "—"}</span>
            <span className="truncate text-[11px] text-stone-600" data-testid={`client-roster-email-${c.id}`}>{c.email || "—"}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
